export function bookingHasSeriesId(seriesId: string | null | undefined): boolean {
  return typeof seriesId === "string" && seriesId.length > 0;
}
